let server = {
  production: {
    host: 'api.neo-psy.com',
    protocol: 'https'
  },
  staging: {
    host: 'api-staging.neo-psy.com',
    protocol: 'https'
  },
  development: {
    host: 'localhost:3000',
    protocol: 'http'
  }
}

let useServer = {
  ...server[process.env.SERVER || 'development']
}

export default function ({protocol = useServer.protocol, host = useServer.host, port = useServer.port, route, id}) {
  let result = protocol + '://' + host
  if (port) {
    result += `:${port}/`
  } else {
    result += '/'
  }
  result += `${route}`
  if (id) {
    result += `/${id}`
  }
  return result
}



// WEBPACK FOOTER //
// ./src/urls.js